var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const getNavigator = () => navigator;
export const hasSharing = () => {
    const $navigator = getNavigator();
    return (typeof $navigator.canShare === 'function' &&
        typeof $navigator.share === 'function');
};
export const share = (output) => __awaiter(void 0, void 0, void 0, function* () {
    const [render] = output !== null && output !== void 0 ? output : [];
    if (!render) {
        throw new Error('Missing render output');
    }
    const file = new File([render.data], render.name, {
        type: render.data.type,
        lastModified: new Date().getTime(),
    });
    const $navigator = getNavigator();
    if (!$navigator.canShare({ files: [file] })) {
        return false;
    }
    return $navigator.share({
        title: 'Annotated image',
        files: [file],
    });
});
